// extracted by mini-css-extract-plugin
export default {"link_blue":"styles_link_blue__bI2cX"};